import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { ReferenceDetail } from "./components/ReferenceDetail";
import { ReferenceFileViewerPage } from "./components/ReferenceFileViewer";
import { ReferencesContainer } from "./components/references.container";

function ReferenceDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.references.detail);
  const navigate = useNavigate();
  return <ReferenceDetail id={id} onBack={() => navigate("..")} />;
}

/** List + detail, mounted under the V2 layout at `/references/*`. */
export function ReferencesRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<ReferencesContainer />} />
        <Route path=":id" element={<ReferenceDetailRoute />} />
      </Routes>
    </Suspense>
  );
}

/** Standalone popup image viewer, mounted WITHOUT the V2 layout at `/reference-files/*`. */
export function ReferenceFilesRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route path=":referenceId/:referenceFileId" element={<ReferenceFileViewerPage />} />
      </Routes>
    </Suspense>
  );
}
